exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.view-container[data-v-25aed984] {\n  max-width: 1140px;\n}\n#footer[data-v-25aed984] {\n  width: 100%;\n  display: inline-block;\n}\n#footer p[data-v-25aed984] {\n  margin-bottom: 5px;\n}\n#footer img[data-v-25aed984] {\n  height: 50px\n}\n", "", {"version":3,"sources":["/builds/tjro/stic/dsi/dides-adm/sesiex/chanceler/frontend/olimpia-front/src/App.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;EACE,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,YAAY;CACb","file":"App.vue","sourcesContent":["\n.view-container[data-v-25aed984] {\n  max-width: 1140px;\n}\n#footer[data-v-25aed984] {\n  width: 100%;\n  display: inline-block;\n}\n#footer p[data-v-25aed984] {\n  margin-bottom: 5px;\n}\n#footer img[data-v-25aed984] {\n  height: 50px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-25aed984","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = g6Dj
// module chunks = 1